module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-screen.75ab4bf6.png";